import router from '@/router';
import type { RouteLocationRaw } from 'vue-router';
import { LINKS } from '@/utils/links';
import { setGoingBack } from '@/animations/navigation-direction';
const MAIN_ROUTE = LINKS.TABS.DASHBOARD;

function getPreviousPath(): string | null {
  const back = window.history.state?.back as string | undefined;
  if (!back) return null;
  // Vue Router hash history stores "/#/path", strip the hash prefix
  return back.replace(/^.*#/, '') || null;
}

export function handleBackNavigation(fallbackRoute?: RouteLocationRaw): void {
  // window.history.state.position est géré par Vue Router (pas le navigateur).
  // position > 0 = on peut remonter dans la pile Ionic sans risque.
  const canGoBack = (window.history.state?.position ?? 0) > 0;
  if (canGoBack && !fallbackRoute) {
    setGoingBack(true);
    router.back();
  } else if (fallbackRoute) {
    setGoingBack(true);
    router.replace(fallbackRoute);
  } else {
    setGoingBack(true);
    router.replace(MAIN_ROUTE);
  }
}

export function goBackInTab(tabPrefix: string, fallbackRoute?: RouteLocationRaw): void {
  const previousPath = getPreviousPath();
  const canGoBack = (window.history.state?.position ?? 0) > 0;
  const previousIsInTab = previousPath?.startsWith(tabPrefix) ?? false;
  if (canGoBack && previousIsInTab) {
    setGoingBack(true);
    router.back();
  } else {
    setGoingBack(true);
    router.replace(fallbackRoute ?? tabPrefix);
  }
}
